export default __webpack_public_path__ + "static/media/rs.51cfe7c9.jpg";